import {HTTP} from '@/CallAPI'
export default {
  getListCommentOfChecklistItem (checklist = {}, checklist_item = {}) {
    return HTTP.get('checklists/' + checklist.id + '/checklist-items/' + checklist_item.id + '/comments')
  },

  showCommentOfChecklistItem (checklist = {}, checklist_item = {}, comment = {}) {
    return HTTP.get('checklists/' + checklist.id + '/checklist-items/' + checklist_item.id + '/comments/' + comment.id)
  },

  createCommentOfChecklistItem (checklist = {}, checklist_item = {}, comment = {}) {
    return HTTP.post('checklists/' + checklist.id + '/checklist-items/' + checklist_item.id + '/comments', comment)
  },

  updateCommentOfChecklistItem (checklist = {}, checklist_item = {}, comment = {}) {
    return HTTP.post('checklists/' + checklist.id + '/checklist-items/' + checklist_item.id + '/comments/' + comment.get('id'), comment)
  },

  destroyCommentOfChecklistItem (checklist = {}, checklist_item = {}, comment = {}) {
    return HTTP.delete('checklists/' + checklist.id + '/checklist-items/' + checklist_item.id + '/comments/' + comment.id)
  },

  setCommentIsFinal (comment) {
    return HTTP.post('comments/' + comment.id + '/final')
  },

  attachFile (file) {
    return HTTP.post('libraries/upload', file)
  }

}



// WEBPACK FOOTER //
// ./src/service/comment.js